import { QuestionOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Tour } from 'antd';
import ru_RU from 'antd/locale/ru_RU';
import styles from './TourComponent.module.css';
import { classNames } from '@/shared/utils';

export const TourComponent = ({ handleOpen, handleClose, isTourOpen, steps, className, ...props }) => {
  return (
    <>
      <Button icon={<QuestionOutlined />} onClick={handleOpen} className={classNames(styles.tourButton, className)} />
      <ConfigProvider locale={ru_RU}>
        <Tour open={isTourOpen} onClose={handleClose} steps={steps} {...props} />
      </ConfigProvider>
    </>
  );
};
